import { createContext, useCallback, useContext, useEffect, useState } from "react";
import Api from "../utils/Api";
import { useSelector } from "react-redux";
import { message } from "antd";

const notificationContent = createContext(null);

export default function NotificationProvider({ children }) {
    const { user } = useSelector((state) => state.user);
    const [notification, setNotification] = useState(null);
    const [isLoading, setIsLoading] = useState(false)

    const fetchNotification = useCallback(async () => {
        try {
            setIsLoading(true);
            const response = await Api.get('/notification');
            setNotification(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchNotification();
    }, [user])

    const addOrUpdateNotification = useCallback(async (values) => {
        try {
            setIsLoading(true);
            if (notification) {
                await Api.put(`/notification/${notification.id}`, values);
            } else {
                await Api.post('notification', values);
            }
            fetchNotification();
        } catch (error) {
            message.error(error?.response?.data?.message || error.message);
        } finally {
            setIsLoading(false);
        }
    }, [notification]);

    const deleteNotification = useCallback(async (id) => {
        try {
            setIsLoading(true);
            await Api.delete(`/notification/${id}`);
            setNotification(null);
        } catch (error) {
            message.error(error?.response?.data?.message || error.message);
        } finally {
            setIsLoading(false);
        }
    }, []);

    const toggleNotification = useCallback(async (id) => {
        try {
            setIsLoading(true);
            await Api.put(`/notification/toggle/${id}`);
        } catch (error) {
            message.error(error?.response?.data?.message || error.message);
            throw new Error(error?.response?.data?.message || error.message)
        } finally {
            setIsLoading(false);
        }
    }, [])


    return (
        <notificationContent.Provider value={{
            notification,
            isLoading,
            addOrUpdateNotification,
            deleteNotification,
            toggleNotification
        }}>
            {children}
        </notificationContent.Provider>
    )
}

export const useNotificationContent = () => useContext(notificationContent);